import React from 'react'
import axios from 'axios'

const API = `AIzaSyCqtgCttisp2qTBbBC71ZBB8P0gT2lqNwU`

export default axios.create({ //creating a baseurl to create a custom fetch constant
    baseURL: 'https://www.googleapis.com/youtube/v3',
    params: {
        part: 'snippet',
        maxResult: 1,
        key: API
    },
    headers: {}
    
})
